export var MarkRole = 'mark';
export var FrameRole = 'frame';
export var ScopeRole = 'scope';

export var AxisRole = 'axis';
export var AxisDomainRole = 'axis-domain';
export var AxisGridRole = 'axis-grid';
export var AxisLabelRole = 'axis-label';
export var AxisTickRole = 'axis-tick';
export var AxisTitleRole = 'axis-title';

export var LegendRole = 'legend';
export var LegendBandRole = 'legend-band';
export var LegendEntryRole = 'legend-entry';
export var LegendGradientRole = 'legend-gradient';
export var LegendLabelRole = 'legend-label';
export var LegendSymbolRole = 'legend-symbol';
export var LegendTitleRole = 'legend-title';

export var TitleRole = 'title';



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-parser/src/parsers/marks/roles.js
// module id = 14
// module chunks = 0